import {PrivateInterceptor} from "../../Base/interceptors/PrivateInterceptor";

// OBTIENER LISTA DE CLIENTES
export const getCustomers = async () => {
    const result = await PrivateInterceptor('Customers', 'GET')
    return result;
};
// OBTIENER LISTA DE DETALLE CLIENTES
export const getCustomersDetail = async (IdCustomer) => {
    const result = await PrivateInterceptor(`Customers/Detail/${IdCustomer}`, 'GET')
    return result;
};

// OBTIENER LISTA DE BUYER
export const getBuyers = async () => {
    const result = await PrivateInterceptor('Customers/Buyers', 'GET')
    return result;
};